'use strict';

import React from 'react';

import { OnSchedDefaults } from '../../../defaults'

import AvailableDay from './AvailableDay/AvailableDay'
import FormCheckbox from '../FormElement/FormCheckbox/FormCheckbox';
import AllocationsForm from './AllocationsForm/AllocationsForm';


const AvailabilityForm = (element, onschedState) => {
  const [availability, setAvailability] = React.useState(OnSchedDefaults.DefaultAvailability)
  const [enabled, setEnabled] = React.useState(OnSchedDefaults.DefaultRecurringAvailability.defaultChecked)
  
  // const displayRecurringOption = element.params.recurringAvailability !== false && element.params.recurringAvailability !== true && element.type !== 'locationSetup';
  const displayRecurringOption = false;
  
  React.useEffect(() => { if (element.params.recurringAvailability === false) setEnabled(false) }, [])

  if (element.options.fields?.availability === false) {
    return null;
  }

  React.useEffect(() => {
    const data = onschedState?.state?.[element.type.replace('Setup', '')];

    if (data) {
      const availabilityKey = data.object === 'location' ? 'businessHours' : 'availability';
      setAvailability(data?.[availabilityKey]);
    }
  }, [onschedState])

  const callback = checked => setEnabled(checked);

  return (
    <div className={`AvailabilityForm${enabled ? '' : ' allocations'}`}>
      { displayRecurringOption && <FormCheckbox input={OnSchedDefaults.DefaultRecurringAvailability} defaultChecked={OnSchedDefaults.DefaultRecurringAvailability.defaultChecked} callback={callback} /> }

      { element.params.recurringAvailability !== false && Object.keys(OnSchedDefaults.DefaultAvailability).map(day => 
        <AvailableDay key={day} element={element} day={day} data={availability[day]} />  
      )}

      {!enabled && <AllocationsForm element={element} onschedState={onschedState} />}
    </div>
  )
}

export default AvailabilityForm
